import { useState } from 'react'
import { SystemSS } from '../../../components/SystemSS'
import { FullScreenModal } from '../../../utility/FullScreenModal'

export const FacilitiesMarina = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            {' '}
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-marina-fr.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        En renforçant votre navire pirate, vous pourrez améliorer les{' '}
                        <span className='text-pborange'>statistiques</span> de toute votre équipe.
                    </p>
                    <br />
                    <p>
                        Les statistiques concernées dépendent du navire pirate que vous choisissez. Certains navires
                        peuvent améliorer l'EXP gagnée pour vous permettre de monter plus rapidement de niveau, tandis
                        que d'autres augmentent le déplacement et le saut, ce qui en fait des atouts sur les cartes avec
                        d'importantes différences de hauteur. Essayez de choisir le navire le plus adapté à votre
                        situation !
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'marina',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'marina',
                                index: 2,
                            },
                            {
                                modalId: 'marina',
                                index: 3,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                </div>
            </section>{' '}
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={3}
            />
        </>
    )
}
